'use strict';

import angular from 'angular';

const SidenavSvc = ['GrpTypeSvc', function(GrpTypeSvc) {
  var observerCallbacks = [];
  var sidenav;

  function setSidenavGroup(groupRole) {
    sidenav = {};
    var group = groupRole.group;
    var ctxId = group.id;
    if(!sidenav) { sidenav = {}; }
    if(!sidenav.header) { sidenav.header = {}; }
    sidenav.header.display = group.name;
    sidenav.header.sref = 'group.view.summary({ctxId:' + ctxId
      + ', groupId:' + ctxId
+ '})';

    var items = [];
    return GrpTypeSvc.getDesc({groupId: ctxId}).$promise.then(function(gt) {
      angular.forEach(gt, function(type) {
        // assumes orgLevels are ordered
        items.push({
          display: type.plural || type.name + 's',
          sref: 'group.list({ctxId:' + ctxId + ', typeId:' + type.id + '})',
          glyph: 'tags'
        });
      });
      sidenav.items = items;
      items.push({
        display: 'Members',
        sref: 'group.memberList({ctxId:' + ctxId + '})',
        glyph: 'user'
      });
      // items.push({
      //   display: 'Help',
      //   // sref: '/groups/' + ctxId + '/help',
      //   glyph: 'question-sign'
      // });
      return sidenav;
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // observer pattern http://stackoverflow.com/a/17558885
  //////////////////////////////////////////////////////////////////////////////
  //register an observer
  function registerObserverCallback(callback) {
    observerCallbacks.push(callback);
    if(sidenav) { return callback(sidenav); }// initialize
  }

  function updateSidenav(group) {
    setSidenavGroup(group)
      .then(function(refreshedSidenav) {
        angular.forEach(observerCallbacks, function(updateNavCb) {
          updateNavCb(refreshedSidenav);
        });
      });
  }

  return {
    registerObserverCallback,
    updateSidenav
  };
}];

export default SidenavSvc;
